import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/expert-guidance"

export const AddExpertGuidance = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const ExpertGuidanceDetails = async () => {
  return await axiosInstance(options).get(`${path}/details`);
};







